<template>
  <section class="degraded-identity-form">
    <form-builder
      :list="listIdentity.forms"
      :is-horizontal="true"
      :errors="$v.form"
      @updateInputs="updatedInputs"
      @updateDateInputs="updatedDateInputs"
      @updateRadioButton="updatedRadioButton"
    />
    <complementary-info
      @updatedRadioButton="updatedConsentRadios"
      :errors="$v.form"
      :btn-is-visibile="false"
    />
    <confidentiality />
  </section>
</template>
<script>
import { mapState } from 'vuex'
import {
  required,
  minLength,
  numeric,
  maxLength,
} from 'vuelidate/lib/validators'
import FormBuilder from '../../shared/inputs/FormBuilder';
import identity from './formData/identity.json'
import ComplementaryInfo from '../../shared/inputs/ComplementaryInfo/ComplementaryInfo'
import Confidentiality from '../../shared/inputs/ComplementaryInfo/Confidentiality'

export default {
  components: {
    ComplementaryInfo,
    FormBuilder,
    Confidentiality,
  },
  data() {
    return {
      listIdentity: identity,
      form: {
        civility: null,
        email: null,
        first_name: null,
        last_name: null,
        phone: null,
        postal_code: null,
        optin_email: null,
        optin_sms: null,

      },
    }
  },
  mounted() {
    this.user()
  },
  computed: {
    ...mapState({
      userDetails: (state) => state.user.details,
    }),
    valid() {
      return !this.$v.$invalid
    },
    bothForms() {
      return { ...this.form }
    },
  },
  watch: {
    bothForms: {
      deep: true,
      handler() {
        this.$emit('updated', this.bothForms)
      },
    },
    userDetails: {
      handler() {
        this.user()
      },
      deep: true,
    },
    valid(newVal) {
      this.$emit('validation', newVal)
    },
  },
  validations: {
    form: {
      civility: { required },
      email: { required },
      first_name: { required, minLength: minLength(2) },
      last_name: { required, minLength: minLength(2) },
      phone: {
        minLength: minLength(10), numeric, maxLength: maxLength(10), required,
      },
      postal_code: { },
      optin_email: { required },
      optin_sms: { required },
    },
  },
  methods: {
    updatedInputs(val) {
      this.form[val.name] = val.value
      this.$v.form[val.name].$touch()
    },
    updatedDateInputs(val) {
      this.form[val.name][val.category] = val.value
      this.$v.form[val.name][val.category].$touch()
    },
    updatedRadioButton(val) {
      this.form[val.name] = val.value
    },
    updatedConsentRadios(val) {
      this.form[val.name] = val.value
    },
    user() {
      if (!this.userDetails) return
      this.form.civility = this.userDetails?.civility
      identity.forms.list[0].selected = this.userDetails?.civility
      // identity.forms.list[0].selected = this.userDetails?.civility
      this.form.email = this.userDetails?.email
      identity.forms.list[1].value = this.userDetails?.email

      /* eslint-disable-next-line camelcase */
      this.form.last_name = this.userDetails?.last_name
      /* eslint-disable-next-line camelcase */
      identity.forms.list[2].value = this.userDetails?.last_name

      /* eslint-disable-next-line camelcase */
      this.form.first_name = this.userDetails?.first_name
      /* eslint-disable-next-line camelcase */
      identity.forms.list[3].value = this.userDetails?.first_name

      this.form.phone = this.userDetails?.tel
      identity.forms.list[4].value = this.userDetails?.tel
    },
  },
}
</script>
<style lang="scss" scoped>

.degraded-identity-form {
  background: $c-alabaster;
  padding: 20px;
  width: 100%;
}

::v-deep .form-builder {
  border: none;
  padding: 0;
}

::v-deep .shared-radio {
  border: none;
  flex-direction: row;
  padding: 0;

  .consent & {
    flex-direction: row-reverse;
  }
}

::v-deep .complementary-info {
  padding: 0;
}
</style>
